import{gql as e}from"@apollo/client";const t=e`
  query getCartoonContentGroup($contentGroupId: Int!) {
    contentGroup {
      getContentGroup(contentGroupId: $contentGroupId) {
        contentPages(status: [PUBLISHED, UNPUBLISHED], topLevelOnly: true) {
          id
          url
          minimumExposureTime
          asset {
            assetId
            presignedUrl
            contentType
            fileName
            fileSizeInBytes
            isAnimatedImage
            presignedUrl
            s3Key
            type
          }
          bubbleTexts {
            angle
            character {
              id
              image {
                presignedUrl
                contentType
                s3Key
              }
              name
              projectId
            }
            characterId
            id
            isTailVisible
            hasShadow
            shape
            tailType
            sort
            text
            w
            x
            y
          }
          audio {
            presignedUrl
          }
          contentPageChildren(status: [PUBLISHED, UNPUBLISHED]) {
            id
            asset {
              assetId
              presignedUrl
              contentType
              fileName
              fileSizeInBytes
              isAnimatedImage
              presignedUrl
              s3Key
              type
            }
            bubbleTexts {
              angle
              character {
                id
                image {
                  presignedUrl
                  contentType
                  s3Key
                }
                name
                projectId
              }
              characterId
              id
              isTailVisible
              hasShadow
              shape
              tailType
              sort
              text
              w
              x
              y
            }
            audio {
              assetId
              presignedUrl
              contentType
              fileName
              fileSizeInBytes
              presignedUrl
              s3Key
              type
            }
            id
            minimumExposureTime
            sort
            url
            title
            parentId
          }
        }
        description
        iconAsset {
          contentType
          s3Key
        }
        regions {
          iconSize
          iconType
          id
          x
          y
        }
        title
        url
      }
    }
  }
`;export{t as GET_CARTOON_CONTENT_GROUP_QUERY};
//# sourceMappingURL=useGetCartoonContentGroup.graphql.js.map
